import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect, useMemo, useRef, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import SpecialAnalysis from "../../../api/SpecialAnalysis/SpecialAnalysis";
import SpecialAnalysisBusinessUnit from "../../../api/SpecialAnalysis/SpecialAnalysisBusinessUnit";
import SpecialAnalysisFileAttachment from "../../../api/SpecialAnalysis/SpecialAnalysisFileAttachment";
import SpecialAnalysisPriority from "../../../api/SpecialAnalysis/SpecialAnalysisPriority";
import SpecialAnalysisStatus from "../../../api/SpecialAnalysis/SpecialAnalysisStatus";

import TrashIcon from "@mui/icons-material/Delete";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  StyledTableBody,
  StyledTableCell,
  StyledTableRow,
  UXDataTableWithoutBody,
} from "../../../components/UXDataTable";
import { GlobalButton } from "../../styles";

import { usePDF } from "@react-pdf/renderer";
import { useFormik } from "formik";
import Location from "../../../api/Admin/Location";
import BillingInfoField from "../../../components/BillingInfoField";
import EmailAddressTextField from "../../../components/EmailAddressField";
import FileDragAndDrop from "../../../components/FileDragAndDrop";
import ModalSimpleButton from "../../../components/Modal/ModalSimpleButton";
import { useUser } from "../../../context/UserContext";
import { useAuth } from "../../../context/AuthContext";
import { Roles } from "../../../constants/roles";
import {
  getMessage,
  isEmailValid,
  DatePickerKeyDownEvent,
  formatCreatedAndModifiedDateInfo,
  downloadFile,
} from "../../../global";

import ModalTwoButtons from "../../../components/Modal/ModalTwoButtons";
import SpecialAnalysisSampleInfoTable from "../NewSpecialAnalysis/components/SpecialAnalysisSampleInfoTable";
import {
  FILE_ATTACHMENT_TABLE_COLUMNS,
  StyledAutocomplete,
  StyledShortTextField,
  StyledTextField,
  SubTitle,
  Title,
  defaultContainer,
  specialAnalysisErrors,
  defaultNewSpecialAnalysisObject,
  DescriptionLink,
  defaultErrorChecksSpecialAnalysis,
} from "../NewSpecialAnalysis/constants.ts";
import NewSpecialAnalysisForm from "../NewSpecialAnalysisForm";
import useContainerStatus from "../hooks/useContainerStatus";
import PrintSpecialAnalysis from "./components/PrintSpecialAnalysis";
import PrintInformation from "../../../components/PrintInformation";
import PrintLabel from "../../../api/LIMS/PrintLabel";

const ViewSpecialAnalysisForm = ({
  mySpecialAnalysis,
  mySpecialAnalysisStatic,
  setMySpecialAnalysis,
  files,
  setFiles,
  billingList,
  fromTab,
  initialStatus,
}) => {
  const { username } = useUser();
  const { hasAnyRole } = useAuth();

  const [newComment, setNewComment] = useState("");
  const [errorChecks, setErrorChecks] = useState(defaultErrorChecksSpecialAnalysis);

  const [modalCancelRequestIsOpen, setModalCancelRequestIsOpen] = useState(false);
  const [modalMessagesOpen, setModalMessagesOpen] = useState(false);
  const [modalMessagesText, setModalMessagesText] = useState("");
  const [modalMessagesTitle, setModalMessagesTitle] = useState("");
  const [modalMessagesButtonText, setModalMessagesButtonText] = useState("Ok");
  const shouldRefresh = useRef(false);
  const { containerStatus } = useContainerStatus();
  const [expanded, setExpanded] = useState("panel1");

  const [requestBusinessUnits, setRequestBusinessUnits] = useState([]);
  const [requestBusinessUnitsLoading, setRequestBusinessUnitsLoading] = useState(true);

  const [locations, setLocations] = useState([]);

  const [requestStatus, setRequestStatus] = useState([]);
  const [requestStatusLoading, setRequestStatusLoading] = useState(true);

  const [priorities, setPriorities] = useState([]);
  const [prioritiesLoading, setPrioritiesLoading] = useState(true);

  const [assignToHasErrors, setAssignToHasErrors] = useState(false);

  const [printLabelInfo, setPrintLabelInfo] = useState(null);
  const [printInfoOpen, setPrintInfoOpen] = useState(false);

  const [readOnly, setReadOnly] = useState(false);
  const [logLogic, setLogLogic] = useState(false);

  const [instance, update] = usePDF({
    document: (
      <PrintSpecialAnalysis
        specialAnalysis={mySpecialAnalysis}
        files={files}
        billingList={billingList}
      />
    ),
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(update, [mySpecialAnalysis, files]);

  let history = useHistory();
  const assignedRef = useRef();

  useEffect(() => {
    if (!assignedRef.current) assignedRef.current = mySpecialAnalysis.assignedToEmail;
  }, [mySpecialAnalysis]);

  const specialAnalysisErrorCheck = specialAnalysisErrors;
  const mustAssignPersonToSpecialAnalysis = false;

  const isCancelledOrCompleted = initialStatus === "Cancelled" || initialStatus === "Completed";
  const isOwner =
    username === mySpecialAnalysis?.requestedByEmail ||
    username === mySpecialAnalysis?.createdByEmail;
  const ownerCanEdit =
    isOwner &&
    (initialStatus === "Submitted" || initialStatus === "OnHold" || initialStatus === "Draft");
  const statusOwnerCanSee = ["OnHold", "Submitted", "Cancelled"];

  const isSpecialAnalysisWorker = hasAnyRole([Roles.SpecialAnalysisWorker, Roles.Developer]);

  const formik = useFormik({
    initialValues: mySpecialAnalysis.specialRequest ?? defaultNewSpecialAnalysisObject,

    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
      setMySpecialAnalysis((prevState) => ({
        ...prevState,
        specialRequest: values,
      }));
      formik.resetForm();
    },
  });

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const isProcessSpecialAnalysis = fromTab === "process";

  useEffect(() => {
    if (
      mySpecialAnalysis.statusName === "Cancelled" ||
      mySpecialAnalysis.statusName === "Completed"
    )
      setReadOnly(true);
    else setReadOnly(false);

    if (mySpecialAnalysis.statusName === "Submitted" || mySpecialAnalysis.statusName === "OnHold") {
      setLogLogic(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mySpecialAnalysis]);

  useMemo(() => {
    if (containerStatus)
      setMySpecialAnalysis((prev) => ({
        ...prev,
        specialAnalysisSamples: [
          ...prev.specialAnalysisSamples.map((sample) => {
            let parentContainer = sample.existingContainer ?? "";
            let currentContainer = sample.newContainer ?? defaultContainer;
            return {
              ...sample,
              newContainer:
                currentContainer.containerNumber > 0
                  ? currentContainer
                  : {
                      ...currentContainer,
                      containerStatusName: "Confirmed",
                      containerStatus: containerStatus.find((x) => x.name === "Confirmed"),
                      parentContainer: sample.existingContainer ?? null,
                      locationName: sample.requestedLocationName,
                      subLocation: sample.deliveryLocationSublocation,
                      ownerEmail: prev.requestedByEmail,
                      containerSizeUoM: sample.requestedAmountUoM,
                      containerTypeName: parentContainer.containerTypeName ?? "",
                      containerType: parentContainer.containerType ?? null,
                      currentAmount: sample.requestedAmount,
                      size: parentContainer.currentAmount,
                    },
            };
          }),
        ],
      }));
  }, [setMySpecialAnalysis, containerStatus]);

  function handleFiles(newFiles) {
    const listFiles = newFiles.map((item) => {
      return {
        file: item,
        sendWithShipment: false,
        isSDS: false,
      };
    });
    setFiles(files.concat(listFiles));
  }

  function deleteFile(file) {
    const newFiles = files.filter((f) => f !== file);

    setFiles(newFiles);
  }

  function AutoCompleteChangeAndValidate(property, value) {
    const copyMySpecialAnalysis = JSON.parse(JSON.stringify(mySpecialAnalysis));
    copyMySpecialAnalysis[property] = value;
    setMySpecialAnalysis(copyMySpecialAnalysis);
  }

  useEffect(() => {
    let cancelPromise = false;

    SpecialAnalysisBusinessUnit.getAll().then((res) => {
      if (cancelPromise) return;
      setRequestBusinessUnitsLoading(false);
      setRequestBusinessUnits(
        res
          .filter((result) => result.isActive === true)
          .sort((a, b) => a.businessUnitName.localeCompare(b.businessUnitName)),
      );
    });

    Location.getAll().then((res) => {
      if (cancelPromise) return;
      setLocations(
        res
          .filter((result) => result.isActive === true)
          .sort((a, b) => a.locationName.localeCompare(b.locationName)),
      );
    });

    SpecialAnalysisStatus.getAll().then((res) => {
      if (cancelPromise) return;
      setRequestStatusLoading(false);
      setRequestStatus(
        res
          .filter((result) => result.isActive === true)
          .sort((a, b) => a.statusName.localeCompare(b.statusName)),
      );
    });

    SpecialAnalysisPriority.getAll().then((res) => {
      if (cancelPromise) return;
      setPrioritiesLoading(false);
      setPriorities(
        res
          .filter((result) => result.isActive === true)
          .sort((a, b) => a.priorityName.localeCompare(b.priorityName)),
      );
    });

    return () => {
      cancelPromise = true;
    };
  }, []);

  const mountComments = (comments) => {
    let comment = "";
    comments.forEach((item) => {
      comment += item + "\n";
    });
    return comment;
  };

  function addComment(comment) {
    let timeStamp = new Date().toLocaleString();
    let commentWithDate = "";

    if (comment) commentWithDate = comment;
    else commentWithDate = `${username} (${timeStamp}): \t ${newComment}`;

    SpecialAnalysis.updateComment(mySpecialAnalysis.id, commentWithDate).then((res) => {
      if (res && res.message === "Success" && res.result && res.result.comments) {
        setMySpecialAnalysis({
          ...mySpecialAnalysis,
          comments: res.result.comments,
        });
        setNewComment("");
      } else {
        setModalMessagesOpen(true);
        setModalMessagesText(
          `Something went wrong, try again later. ${res?.message ? res?.message : ""}`,
        );
        setModalMessagesButtonText("Ok");
        setModalMessagesTitle("Special Analysis Comment");
      }
    });
  }

  function printRequest() {
    if (!instance.loading && !instance.error && instance.url) {
      const link = document.createElement("a");
      link.href = instance.url;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  const jadeRequired = true;

  const areFieldsInvalidFunc = () => {
    let fieldsInvalidList = [];
    let hasError = false;
    let businessUnitName = null;
    let requestedByEmail = null;
    let statusName = null;
    let chargeCode = null;

    if (mySpecialAnalysis.statusName !== "Draft") {
      if (!mySpecialAnalysis.assignedToEmail && mustAssignPersonToSpecialAnalysis) {
        setAssignToHasErrors(true);
        hasError = true;
        fieldsInvalidList.push("Assigned To");
      }
      if (!mySpecialAnalysis.businessUnitName) {
        fieldsInvalidList.push("Business Unit");
        businessUnitName = getMessage("REQUIRED_FIELD");
      }
      if (!mySpecialAnalysis.requestedByEmail) {
        fieldsInvalidList.push("Requester Name");
        requestedByEmail = getMessage("REQUIRED_FIELD");
      } else if (!isEmailValid(mySpecialAnalysis.requestedByEmail)) {
        fieldsInvalidList.push("Requester Name");
        requestedByEmail = "Invalid E-mail";
      }

      if (!mySpecialAnalysis.statusName) {
        fieldsInvalidList.push("Status");
        statusName = getMessage("REQUIRED_FIELD");
      }

      if (mySpecialAnalysis.priorityName === "Rush" && !mySpecialAnalysis.priorityReason) {
        fieldsInvalidList.push("Priority Reason");
        hasError = true;
      }

      if (!mySpecialAnalysis.chargeCode && jadeRequired) {
        fieldsInvalidList.push("JADE Number");
        chargeCode = getMessage("REQUIRED_FIELD");
      }

      setErrorChecks({
        ...errorChecks,
        businessUnitName: businessUnitName,
        requestedByEmail: requestedByEmail,
        statusName: statusName,
        chargeCode: chargeCode,
      });
    }

    const invalidAssignedPersonToSpecialAnalysis =
      assignToHasErrors && mustAssignPersonToSpecialAnalysis;

    return {
      hasError:
        businessUnitName !== null ||
        requestedByEmail !== null ||
        statusName !== null ||
        chargeCode !== null ||
        invalidAssignedPersonToSpecialAnalysis ||
        hasError,
      fields: fieldsInvalidList,
    };
  };

  const prepareData = (specialAnalysis, isCopy = false) => {
    const specialAnalysisSamples = specialAnalysis.specialAnalysisSamples.filter(
      (wrs) => wrs.sample,
    );
    return {
      ...specialAnalysis,
      businessUnitName: specialAnalysis.businessUnitName,
      businessUnit: null,
      specialAnalysisSamples: specialAnalysisSamples.map((sample) => {
        return {
          ...sample,
          sample: isCopy ? sample.sample : null,
          sampleName: sample.sample?.sampleName,
          unitOfMeasure: null,
          requestedAmountUoM: sample.requestedAmountUoM,
          requestedAmount: sample.requestedAmount ?? 0,
          location: null,
          requestedLocationName: sample.requestedLocationName,
          container: null,
          existingContainerID: sample.existingContainerID,
          existingContainer: null,
          newContainer: sample.newContainer
            ? {
                ...sample.newContainer,
                uom: null,
                location: null,
                containerStatus: null,
                containerType: null,
                parentID: sample.newContainer?.parentContainer?.id ?? null,
                parentContainer: null,
              }
            : null,
        };
      }),
    };
  };

  function sendFiles(id) {
    const filesToCreate = files.filter((f) => !f.file?.id);
    const filesToUpdate = files.filter((f) => f.file?.id);
    const lastIndexToCreate = filesToCreate.length - 1;
    const lastIndexsToUpdate = filesToUpdate.length - 1;
    let finishUpdate = true;
    let finishCreate = true;
    let error = false;
    filesToCreate.forEach((file, index) => {
      finishCreate = false;
      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("specialAnalysisID", id);
      formData.append("sendWithShipment", file.sendWithShipment);
      formData.append("isSDS", file.isSDS);

      SpecialAnalysisFileAttachment.postAttachments(formData)
        .then((res) => {
          if (res && !res.result && res.message) {
            error = true;
          }

          if (lastIndexToCreate === index && finishUpdate) {
            const message = error
              ? `Special Analysis Updated, but Something went wrong with the attachments: ${res.message}`
              : "Special Analysis Updated with success";
            finallyUpdate(message, !error);
            finishCreate = true;
          }
        })
        .catch((resp) => {
          error = true;
          if (lastIndexToCreate === index && finishUpdate) {
            console.log(resp);
            const message = error
              ? `Special Analysis Updated, but Something went wrong with the attachments: ${resp.message}`
              : "Special Analysis Updated with success";
            finallyUpdate(message, !error);
            finishCreate = true;
          }
        });
    });

    filesToUpdate.forEach((file, index) => {
      SpecialAnalysisFileAttachment.updateAttachments(file.file)
        .then((res) => {
          if (res && !res.result && res.message) {
            error = true;
          }
          if (lastIndexsToUpdate === index && finishCreate) {            
            const message = error
              ? `Special Analysis Updated, but Something went wrong with the attachments: ${res.message}`
              : "Special Analysis Updated with success";
            finallyUpdate(message, !error);
            finishUpdate = true;
          }
        })
        .catch((resp) => {
          error = true;
          if (lastIndexsToUpdate === index && finishCreate) {
            const message = error
              ? `Special Analysis Updated, but Something went wrong with the attachments: ${resp.message}`
              : "Special Analysis Updated with success";
            finallyUpdate(message, !error);
            finishUpdate = true;
          }
        });
    });
  }

  function finallyUpdate(message, redirect) {
    setModalMessagesOpen(true);
    setModalMessagesText(message);
    setModalMessagesButtonText("Ok");
    setModalMessagesTitle("Special Analysis Update");

    shouldRefresh.current = redirect;
  }

  function closeModalMessages() {
    setModalMessagesOpen(false);
    setModalMessagesText("");
    setModalMessagesButtonText("");
    setModalMessagesTitle("");
    if (shouldRefresh.current) history.push("/processSpecialAnalysis");
  }

  function openModalMessages(title, text) {
    setModalMessagesOpen(true);
    setModalMessagesTitle(title);
    setModalMessagesText(text);
    setModalMessagesButtonText("Ok");
  }

  function submit() {
    const areFieldsInvalid = areFieldsInvalidFunc();

    if (areFieldsInvalid.hasError) {
      const fields = areFieldsInvalid.fields.join("\n");
      setModalMessagesOpen(true);
      setModalMessagesText("There are required fields missing:\n\n" + fields);
      setModalMessagesButtonText("Ok");
      setModalMessagesTitle("Missing information!");
      return;
    }
    const data = prepareData(mySpecialAnalysis);
    // data.isWorkRequestRedesign = featureToggle.WorkRequestRedesign;
    data.isWorkRequestRedesign = false;

    if (logLogic) compareSpecialAnalysiss();

    SpecialAnalysis.updateSpecialAnalysis(data)
      .then((res) => {
        if (res?.message !== "Success") {
          finallyUpdate(
            `Something went wrong, try again later. ${res?.message ? res?.message : ""}`,
            false,
          );
        } else {
          if (files.length > 0) {
            sendFiles(res.result.id);
          } else {
            finallyUpdate("Special Analysis Updated with success", true);
          }
        }
      })
      .catch((err) => {
        finallyUpdate(
          `Something went wrong, try again later. ${err?.message ? err?.message : ""}`,
          false,
        );
      });
  }

  function compareSpecialAnalysiss() {
    let newComments = "";

    if (mySpecialAnalysisStatic.assignedDate !== mySpecialAnalysis.assignedDate) {
      newComments += getLogLogicComment(
        mySpecialAnalysisStatic.assignedDate,
        mySpecialAnalysis.assignedDate,
      );
    }
    if (mySpecialAnalysisStatic.assignedToEmail !== mySpecialAnalysis.assignedToEmail) {
      newComments += getLogLogicComment(
        mySpecialAnalysisStatic.assignedToEmail,
        mySpecialAnalysis.assignedToEmail,
      );
    }
    if (mySpecialAnalysisStatic.businessUnitName !== mySpecialAnalysis.businessUnitName) {
      newComments += getLogLogicComment(
        mySpecialAnalysisStatic.businessUnitName,
        mySpecialAnalysis.businessUnitName,
      );
    }
    if (mySpecialAnalysisStatic.chargeCode !== mySpecialAnalysis.chargeCode) {
      newComments += getLogLogicComment(
        mySpecialAnalysisStatic.chargeCode,
        mySpecialAnalysis.chargeCode,
      );
    }
    if (mySpecialAnalysisStatic.description !== mySpecialAnalysis.description) {
      newComments += getLogLogicComment(
        mySpecialAnalysisStatic.description,
        mySpecialAnalysis.description,
      );
    }
    if (mySpecialAnalysisStatic.priorityName !== mySpecialAnalysis.priorityName) {
      newComments += getLogLogicComment(
        mySpecialAnalysisStatic.priorityName,
        mySpecialAnalysis.priorityName,
      );
    }
    if (mySpecialAnalysisStatic.priorityReason !== mySpecialAnalysis.priorityReason) {
      newComments += getLogLogicComment(
        mySpecialAnalysisStatic.priorityReason,
        mySpecialAnalysis.priorityReason,
      );
    }
    if (
      mySpecialAnalysisStatic.specialRequest.dataClassificationName !==
      mySpecialAnalysis.specialRequest.dataClassificationName
    ) {
      newComments += getLogLogicComment(
        mySpecialAnalysisStatic.specialRequest.dataClassificationName,
        mySpecialAnalysis.specialRequest.dataClassificationName,
      );
    }
    if (
      mySpecialAnalysisStatic.specialRequest.requestDescription !==
      mySpecialAnalysis.specialRequest.requestDescription
    ) {
      newComments += getLogLogicComment(
        mySpecialAnalysisStatic.specialRequest.requestDescription,
        mySpecialAnalysis.specialRequest.requestDescription,
      );
    }
    if (
      mySpecialAnalysisStatic.specialRequest.requestReason !==
      mySpecialAnalysis.specialRequest.requestReason
    ) {
      newComments += getLogLogicComment(
        mySpecialAnalysisStatic.specialRequest.requestReason,
        mySpecialAnalysis.specialRequest.requestReason,
      );
    }
    if (
      mySpecialAnalysisStatic.specialRequest.testingRequirements !==
      mySpecialAnalysis.specialRequest.testingRequirements
    ) {
      newComments += getLogLogicComment(
        mySpecialAnalysisStatic.specialRequest.testingRequirements,
        mySpecialAnalysis.specialRequest.testingRequirements,
      );
    }
    if (mySpecialAnalysisStatic.statusName !== mySpecialAnalysis.statusName) {
      newComments += getLogLogicComment(
        mySpecialAnalysisStatic.statusName,
        mySpecialAnalysis.statusName,
      );
    }

    if (newComments) addComment(newComments);
  }

  function getLogLogicComment(oldVal, newVal) {
    let str = `${username} (${new Date().toLocaleString()}): \t `;
    return str + "Old value: '" + oldVal + "'. New value: '" + newVal + "'|";
  }

  const cancelRequest = () => {
    SpecialAnalysis.cancelRequest(mySpecialAnalysis.id)
      .then((res) => {
        if (res?.message !== "Success") {
          finallyUpdate(
            `Something went wrong, try again later. ${res?.message ? res?.message : ""}`,
            false,
          );
        } else {
          finallyUpdate("Special Analysis Updated with success", true);
        }
      })
      .catch((err) => {
        finallyUpdate("Something went wrong, try again later.", false);
      });
  };

  function HandleFileDownload(file) {
    downloadFile("specialanalysisfiles", file.fileName, file.storagePath, openModalMessages);
  }

  function closePrintInformation() {
    setPrintInfoOpen(false);
  }

  function OpenPrintingOptions(sampleList, onlyWithBlindCode) {
    let arrayPrintInfo = [];

    const hasNewContainers = sampleList.some(
      (s) => s.newContainer?.containerNumber || s.newContainer?.containerNumber === 0,
    );

    if (hasNewContainers) {
      sampleList.forEach((dataTable) => {
        if (dataTable?.sample) {
          // const existingContainer = dataTable.existingContainer ?? dataTable?.sample?.containers.find(f=> f.id === dataTable.existingContainerID);
          // const containerNumbers = existingContainer?.containerNumber || existingContainer?.containerNumber === 0 ? [`${existingContainer?.containerNumber}`] :
          //   dataTable.newContainer?.containerNumber || dataTable.newContainer?.containerNumber === 0 ? [`${dataTable.newContainer?.containerNumber}`] : [];
          const containerNumbers =
            dataTable.newContainer?.containerNumber || dataTable.newContainer?.containerNumber === 0
              ? [`${dataTable.newContainer?.containerNumber}`]
              : [];

          let newPrintInfo = new PrintLabel({
            sampleName: dataTable.sample.sampleName,
            containerNumbers: containerNumbers,
            includeAdditionalSampleInformation: false,
            chemIDOnly: false,
            printLabelSizeType: null,
            isBlindCoded: onlyWithBlindCode,
            blindDescription: null,
            blindSampleName: null,
            isShelfLabel: false,
            shelfLabelText: null,
            includeShelfBarcode: false,
          });

          arrayPrintInfo.push(newPrintInfo);
        }
      });

      setPrintLabelInfo(arrayPrintInfo);
      setPrintInfoOpen(true);
    } else {
      openModalMessages("", "A container needs to be created to be able to print!");
    }
  }

  return (
    <div>
      <div style={{ paddingBottom: "50px" }}>
        <Accordion expanded={expanded === "panel1"} onChange={handleChange("panel1")}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            //   ref={formRequestDetailsRef}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 15 }}>
              <Title>Request Details - {mySpecialAnalysis?.id}</Title>
              <GlobalButton
                name="copy"
                variant="outlined"
                component={Link}
                to={{
                  pathname: "/newSpecialAnalysis",
                  state: { mySpecialAnalysis: prepareData(mySpecialAnalysis, true) },
                }}>
                Copy Special Analysis
              </GlobalButton>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <SubTitle>Special Analysis Common Info</SubTitle>
            {mySpecialAnalysis && mySpecialAnalysis.completedByEmail && (
              <div style={{ marginTop: "1rem", marginBottom: "0.5rem" }}>
                <p style={{ fontSize: "15px" }}>
                  Completed by: {mySpecialAnalysis.completedByEmail}
                </p>
              </div>
            )}
            <Grid container spacing={2}>
              {isProcessSpecialAnalysis && (
                <Grid item xs={3} md={3}>
                  <EmailAddressTextField
                    fontSize={16}
                    margin="normal"
                    validatedUserEmail={
                      mySpecialAnalysis.assignedToEmail === null
                        ? ""
                        : mySpecialAnalysis.assignedToEmail
                    }
                    setValidatedUserEmail={(value) => {
                      setMySpecialAnalysis(() => ({
                        ...mySpecialAnalysis,
                        assignedToEmail: value,
                      }));
                    }}
                    setHasErrors={(value) => {
                      setAssignToHasErrors(value);
                    }}
                    hasErrors={assignToHasErrors && mustAssignPersonToSpecialAnalysis}
                    isDisabled={!isSpecialAnalysisWorker}
                    labelText="Assigned To"
                    placeholderText="Assigned To"
                    showPlusMeButton={isSpecialAnalysisWorker}
                  />
                </Grid>
              )}
              <Grid item xs={4} md={2}>
                <StyledAutocomplete
                  style={{ width: "100%" }}
                  // disabled={!isSpecialAnalysisWorker && !ownerCanEdit}
                  disabled={isCancelledOrCompleted}
                  disablePortal
                  noOptionsText={requestStatusLoading ? "Loading Status..." : "No Status Found"}
                  options={
                    isProcessSpecialAnalysis
                      ? requestStatus
                      : ownerCanEdit
                      ? requestStatus.filter((f) => statusOwnerCanSee.includes(f.statusName))
                      : requestStatus
                  }
                  getOptionLabel={(option) =>
                    option?.statusName
                      ? option.statusName
                      : requestStatus.length > 0
                      ? requestStatus.find((f) => f.statusName === option)?.statusName
                      : ``
                  }
                  onChange={(e, value) =>
                    AutoCompleteChangeAndValidate("statusName", value?.statusName)
                  }
                  autoHighlight
                  autoSelect
                  value={mySpecialAnalysis.statusName}
                  isOptionEqualToValue={(option, value) => value?.statusName === option?.statusName}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      margin="normal"
                      label="Status"
                      error={errorChecks.statusName === null ? false : errorChecks.statusName}
                      helperText={errorChecks.statusName ? errorChecks.statusName : ""}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ ...params.InputProps }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={4} md={2}>
                <StyledAutocomplete
                  style={{ width: "100%" }}
                  disabled={!isSpecialAnalysisWorker && !ownerCanEdit}
                  disablePortal
                  noOptionsText={
                    requestBusinessUnitsLoading
                      ? "Loading Business Units..."
                      : "No Business Units Found"
                  }
                  options={requestBusinessUnits}
                  onChange={(e, value) =>
                    AutoCompleteChangeAndValidate("businessUnitName", value?.businessUnitName)
                  }
                  getOptionLabel={(option) =>
                    option?.businessUnitName
                      ? option.businessUnitName
                      : requestBusinessUnits.length > 0
                      ? requestBusinessUnits.find((f) => f.businessUnitName === option)
                          ?.businessUnitName
                      : ``
                  }
                  autoHighlight
                  autoSelect
                  value={mySpecialAnalysis.businessUnitName}
                  isOptionEqualToValue={(option, value) =>
                    value?.businessUnitName === option?.businessUnitName
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      margin="normal"
                      label="* Business Unit"
                      error={
                        errorChecks.businessUnitName === null ? false : errorChecks.businessUnitName
                      }
                      helperText={errorChecks.businessUnitName ? errorChecks.businessUnitName : ""}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ ...params.InputProps }}
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              {mySpecialAnalysis.statusName === "Draft" && (
                <Grid item xs={20} md={20}>
                  <EmailAddressTextField
                    fontSize={16}
                    margin={"none"}
                    fieldWidth={"20%"}
                    validatedUserEmail={
                      mySpecialAnalysis.requestedByEmail === null
                        ? ""
                        : mySpecialAnalysis.requestedByEmail
                    }
                    setValidatedUserEmail={(value) => {
                      setMySpecialAnalysis(() => ({
                        ...mySpecialAnalysis,
                        requestedByEmail: value,
                      }));
                    }}
                    setHasErrors={() => {
                      setErrorChecks((prev) => ({
                        ...prev,
                        requestedByEmail: "Invalid E-mail",
                      }));
                    }}
                    hasErrors={
                      errorChecks.requestedByEmail === null ? false : errorChecks.requestedByEmail
                    }
                    isDisabled={false}
                    labelText="* Requester Email"
                    placeholderText="* Requester Email"
                    showPlusMeButton={true}
                  />
                </Grid>
              )}

              {mySpecialAnalysis.statusName !== "Draft" && (
                <Grid item xs={4} md={4}>
                  <StyledTextField
                    size="small"
                    margin="normal"
                    variant="outlined"
                    label="Requester Name"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ maxLength: 60 }}
                    // onChange={(e) =>
                    //   setMySpecialAnalysis(() => ({
                    //     ...mySpecialAnalysis,
                    //     requestedByEmail: e.target.value,
                    //   }))
                    // }
                    value={
                      mySpecialAnalysis.requestedByEmail === null
                        ? ""
                        : mySpecialAnalysis.requestedByEmail
                    }
                    // error={
                    //   errorChecks.requestedByEmail === null
                    //     ? false
                    //     : errorChecks.requestedByEmail
                    // }
                    // helperText={
                    //   errorChecks.requestedByEmail
                    //     ? errorChecks.requestedByEmail
                    //     : ""
                    // }
                    disabled={mySpecialAnalysis.statusName !== "Draft"}
                  />
                </Grid>
              )}
              <Grid item xs={3} md={3}>
                <BillingInfoField
                  billingValue={
                    mySpecialAnalysis.chargeCode === null ? "" : mySpecialAnalysis.chargeCode
                  }
                  handleChange={(e) => {
                    setMySpecialAnalysis(() => ({
                      ...mySpecialAnalysis,
                      chargeCode: e,
                    }));
                  }}
                  hasErrors={errorChecks.chargeCode === null ? false : errorChecks.chargeCode}
                  isDisabled={!isSpecialAnalysisWorker && !ownerCanEdit}
                  margin="normal"
                  fieldWidth="100%"
                  helperText={errorChecks.chargeCode ? errorChecks.chargeCode : ""}
                  marginLeft={null}
                  marginRight={null}
                  required={jadeRequired}
                />
              </Grid>
              <Grid item xs={2} md={2}>
                <StyledTextField
                  disabled={true}
                  size="small"
                  margin="normal"
                  variant="outlined"
                  label="Created Date"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 60 }}
                  onChange={(e) => {}}
                  value={
                    mySpecialAnalysis.createdDate === null
                      ? ""
                      : new Date(mySpecialAnalysis.createdDate).toLocaleString()
                  }
                  error={errorChecks.createdDate === null ? false : errorChecks.createdDate}
                  helperText={errorChecks.createdDate ? errorChecks.createdDate : ""}
                />
              </Grid>
              <Grid item xs={2} md={2}>
                <StyledTextField
                  disabled={true}
                  size="small"
                  margin="normal"
                  variant="outlined"
                  label="Last Modified Date"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 60 }}
                  onChange={(e) => {}}
                  value={
                    mySpecialAnalysis.lastModifiedDate === null
                      ? ""
                      : new Date(mySpecialAnalysis.lastModifiedDate).toLocaleString()
                  }
                  error={
                    errorChecks.lastModifiedDate === null ? false : errorChecks.lastModifiedDate
                  }
                  helperText={errorChecks.lastModifiedDate ? errorChecks.lastModifiedDate : ""}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={10} md={8}>
                <StyledTextField
                  disabled={!isSpecialAnalysisWorker && !ownerCanEdit}
                  size="small"
                  margin="normal"
                  variant="outlined"
                  label="Request Description"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 500 }}
                  multiline
                  rows={4}
                  value={mySpecialAnalysis.description}
                  onChange={(e) =>
                    setMySpecialAnalysis(() => ({
                      ...mySpecialAnalysis,
                      description: e.target.value,
                    }))
                  }
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={3} md={2}>
                <StyledAutocomplete
                  style={{ width: "100%" }}
                  disabled={!isSpecialAnalysisWorker && !ownerCanEdit}
                  disablePortal
                  noOptionsText={
                    prioritiesLoading ? "Loading Priorities..." : "No Priorities Found"
                  }
                  options={priorities}
                  getOptionLabel={(option) =>
                    option?.priorityName
                      ? option.priorityName
                      : priorities.length > 0
                      ? priorities.find((f) => f.priorityName === option)?.priorityName
                      : ``
                  }
                  onChange={(e, value) =>
                    AutoCompleteChangeAndValidate("priorityName", value?.priorityName)
                  }
                  autoHighlight
                  autoSelect
                  value={mySpecialAnalysis.priorityName}
                  isOptionEqualToValue={(option, value) =>
                    value?.priorityName === option?.priorityName
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      margin="normal"
                      label="Priority"
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ ...params.InputProps }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={5} md={3}>
                <StyledTextField
                  disabled={!isSpecialAnalysisWorker && !ownerCanEdit}
                  size="small"
                  margin="normal"
                  variant="outlined"
                  label="Priority Reason"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 100 }}
                  value={mySpecialAnalysis.priorityReason}
                  onChange={(e) =>
                    setMySpecialAnalysis(() => ({
                      ...mySpecialAnalysis,
                      priorityReason: e.target.value,
                    }))
                  }
                  error={
                    mySpecialAnalysis.priorityName === "Rush" && !mySpecialAnalysis.priorityReason
                  }
                />
              </Grid>
              <Grid item xs={3} md={1.5}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    disabled={!isSpecialAnalysisWorker && !ownerCanEdit}
                    size="small"
                    inputFormat="MM/dd/yyyy"
                    label="Request Completion Date"
                    onChange={(e) =>
                      setMySpecialAnalysis(() => ({
                        ...mySpecialAnalysis,
                        requestedCompletionDate: e,
                      }))
                    }
                    minDate={new Date()}
                    value={mySpecialAnalysis.requestedCompletionDate}
                    renderInput={(params) => (
                      <StyledShortTextField
                        onKeyDown={DatePickerKeyDownEvent}
                        style={{ width: "100%" }}
                        {...params}
                        margin="normal"
                        variant="outlined"
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ ...params.inputProps }}
                        InputProps={{ ...params.InputProps }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={3} md={1.5}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    disabled={!isSpecialAnalysisWorker && !ownerCanEdit}
                    size="small"
                    inputFormat="MM/dd/yyyy"
                    label="Last Acceptable Date"
                    onChange={(e) =>
                      setMySpecialAnalysis(() => ({
                        ...mySpecialAnalysis,
                        lastAcceptableCompletionDate: e,
                      }))
                    }
                    minDate={new Date()}
                    value={mySpecialAnalysis.lastAcceptableCompletionDate}
                    renderInput={(params) => (
                      <StyledShortTextField
                        onKeyDown={DatePickerKeyDownEvent}
                        style={{ width: "100%" }}
                        {...params}
                        margin="normal"
                        variant="outlined"
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ ...params.inputProps }}
                        InputProps={{ ...params.InputProps }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={3} md={1.5}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    disabled={!isSpecialAnalysisWorker && !ownerCanEdit}
                    size="small"
                    inputFormat="MM/dd/yyyy"
                    label="Date Completed"
                    onChange={(e) =>
                      setMySpecialAnalysis(() => ({
                        ...mySpecialAnalysis,
                        completedDate: e,
                      }))
                    }
                    minDate={new Date()}
                    value={mySpecialAnalysis.completedDate}
                    renderInput={(params) => (
                      <StyledShortTextField
                        onKeyDown={DatePickerKeyDownEvent}
                        style={{ width: "100%" }}
                        {...params}
                        margin="normal"
                        variant="outlined"
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ ...params.inputProps }}
                        InputProps={{ ...params.InputProps }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
            {formatCreatedAndModifiedDateInfo(
              mySpecialAnalysis.createdDate,
              mySpecialAnalysis.createdByEmail,
              mySpecialAnalysis.lastModifiedDate,
              mySpecialAnalysis.lastModifiedByEmail,
            )}
            <SubTitle>Add Comment</SubTitle>
            <Grid container spacing={2}>
              <Grid item xs={8} md={8}>
                <StyledTextField
                  multiline
                  disabled={!isSpecialAnalysisWorker && !isOwner}
                  size="small"
                  margin="normal"
                  variant="outlined"
                  label="Comment"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 100 }}
                  value={newComment}
                  onChange={(e) => setNewComment(e.target.value)}
                />
              </Grid>
              <Grid
                item
                xs={4}
                md={4}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "6px",
                }}>
                <GlobalButton
                  name="saveComment"
                  variant="contained"
                  onClick={() => addComment()}
                  disabled={newComment === "" || !newComment || (!isSpecialAnalysisWorker && !isOwner)}>
                  Save Comment
                </GlobalButton>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={10} md={8}>
                <StyledTextField
                  size="small"
                  margin="normal"
                  variant="outlined"
                  label="Comments History"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 500 }}
                  multiline
                  rows={4}
                  value={
                    mySpecialAnalysis.comments
                      ? mountComments(mySpecialAnalysis.comments.split("|"))
                      : ""
                  }
                  disabled
                />
              </Grid>
            </Grid>

            <SubTitle style={{ marginBottom: "16px" }}>
              Request Containers{" "}
              {isProcessSpecialAnalysis && (
                <DescriptionLink
                  onClick={() => {
                    OpenPrintingOptions(mySpecialAnalysis?.specialAnalysisSamples, false);
                  }}>
                  Print
                </DescriptionLink>
              )}
            </SubTitle>
            <Grid container>
              <Grid item width={"100%"}>
                <SpecialAnalysisSampleInfoTable
                  mySpecialAnalysis={mySpecialAnalysis}
                  setMySpecialAnalysis={setMySpecialAnalysis}
                  locations={locations}
                  ownerCanEdit={ownerCanEdit}
                  isProcessorRole={isSpecialAnalysisWorker}
                />
              </Grid>
            </Grid>

            <SubTitle>File Attachments</SubTitle>
            <FileDragAndDrop
              // disabled={!isSpecialAnalysisWorker && !ownerCanEdit}
              disabled={isCancelledOrCompleted}
              handleFiles={handleFiles}
              files={files.map((item) => item.file)}
              showFiles={false}></FileDragAndDrop>
            <div
              style={{
                width: "50%",
                minWidth: "800px",
              }}>
              <UXDataTableWithoutBody
                tableWidth="100%"
                cols={FILE_ATTACHMENT_TABLE_COLUMNS}
                blankFirstHeader={true}
                tableId="midasFileAttachments"
                rowLength={files.length}
                enablePaging={false}
                rowsPerPage={files.length}
                page={0}
                handleChangePage={null}
                handleChangeRowsPerPage={null}
                noDataFoundMessage={"No Files Added"}
                enableAddIcon={false}
                addFunction={() => null}
                addToolTipText=""
                isDataLoading={false}>
                <StyledTableBody key={"myTablebody"}>
                  {files.map((file, rowIndex) => {
                    return (
                      <StyledTableRow hover key={`custom-row-${rowIndex}`}>
                        <StyledTableCell component="th" scope="row">
                          <IconButton
                            aria-label="upload"
                            component="span"
                            onClick={() => deleteFile(file)}
                            disabled={file.file.id || isCancelledOrCompleted ? true : false}>
                            <TrashIcon />
                          </IconButton>
                        </StyledTableCell>
                        <StyledTableCell>
                          <Button
                            style={{ textTransform: "none" }}
                            onClick={(e) => HandleFileDownload(file.file)}>
                            {file.file.name}
                          </Button>
                          {/* {file.file.filePath ? (
                            <a href={file.file.filePath}>{file.file.name}</a>
                          ) : (
                            <span>{file.file.name}</span>
                          )} */}
                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  })}
                </StyledTableBody>
              </UXDataTableWithoutBody>
            </div>
            {mySpecialAnalysis && (
              <NewSpecialAnalysisForm
                mySpecialAnalysis={mySpecialAnalysis}
                specialAnalysisErrorCheck={specialAnalysisErrorCheck}
                formik={formik}
                readOnly={readOnly}
                isProcessorRole={isSpecialAnalysisWorker}
                setMySpecialAnalysis={setMySpecialAnalysis}
                isCancelledOrCompleted={isCancelledOrCompleted}
                ownerCanEdit={ownerCanEdit}
              />
            )}
            {mySpecialAnalysis.workRequestID ? (
              <div style={{ marginTop: "20px" }}>
                Associated On-site Transport work request : &nbsp;
                <Link
                  to={`${
                    "/newWorkRequestRedesign/"
                  }${mySpecialAnalysis.workRequestID}`}>
                  {mySpecialAnalysis.workRequestID}
                </Link>
              </div>
            ) : (
              <FormControlLabel
                style={{ marginTop: "20px" }}
                label="Create associated On-site Transport work request"
                onChange={(e) =>
                  setMySpecialAnalysis(() => ({
                    ...mySpecialAnalysis,
                    isCreateOnsiteTransportRequest: e.target.checked,
                  }))
                }
                checked={mySpecialAnalysis.isCreateOnsiteTransportRequest}
                control={<Checkbox />}
                disabled={isCancelledOrCompleted}
              />
            )}
            <PrintInformation
              open={printInfoOpen}
              setOpen={setPrintInfoOpen}
              button2Action={closePrintInformation}
              button2Text={"Close"}
              printLabelInfo={printLabelInfo}
              isShelfLabel={false}
              useFieldsBlindCode={false}></PrintInformation>
          </AccordionDetails>
        </Accordion>

        <ModalSimpleButton
          title={modalMessagesTitle}
          buttonText={modalMessagesButtonText}
          buttonAction={closeModalMessages}
          open={modalMessagesOpen}
          setOpen={setModalMessagesOpen}>
          <label style={{ whiteSpace: "break-spaces" }}>{modalMessagesText}</label>
        </ModalSimpleButton>
      </div>
      <div
        style={{
          position: "fixed",
          width: "8%",
          height: "100%",
          right: 0,
          top: 0,
          padding: "16px 8px",
          display: "flex",
          flexDirection: "column-reverse",
          gap: "8px",
        }}>
        <GlobalButton
          name="btnSave"
          variant="contained"
          onClick={() => submit()}
          disabled={!ownerCanEdit && (isCancelledOrCompleted || !isSpecialAnalysisWorker)}>
          Save Changes
        </GlobalButton>

        <GlobalButton name="btnPrint" variant="outlined" onClick={printRequest}>
          {instance.loading ? "Loading Print" : "Print Request"}
        </GlobalButton>
      </div>
      <ModalTwoButtons
        title={`Cancel Special Analysis #${mySpecialAnalysis.id}`}
        button1Text={"Confirm"}
        button1Action={cancelRequest}
        button2Text={"Close"}
        button2Action={() => setModalCancelRequestIsOpen(false)}
        open={modalCancelRequestIsOpen}
      />
    </div>
  );
};

export default ViewSpecialAnalysisForm;
